module.exports = __webpack_public_path__ + "img/peserta.f1efb5f8.svg";